import { useLocation } from "react-router-dom";
import i18next from "i18next";
import { 
  IoGridOutline, 
  IoReceiptOutline, 
  IoDocumentTextOutline,
  IoChatbubblesOutline,
} from "react-icons/io5";

import { useAuth } from "../../../context/auth";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import HeaderLogoComponent from "../HeaderLogoComponent";
import HeaderNavigationComponent from "../HeaderNavigationComponent";

import { 
  StyledContainer, 
  Wrapper, 
  LeftSection,
  NavTabs,
  NavTab,
  NavIcon,
  NavText,
} from "./style";
import { SupportUnreadBadge } from "../../support";

const HeaderComponent = () => {
  const { t } = i18next;
  const { isAuth } = useAuth();
  const { width } = useWindowDimensions();
  const location = useLocation();

  // Navigation items for authenticated users
  const authNavItems = [
    { path: "/services", icon: IoGridOutline, label: t("services") || "Services" },
    { path: "/transactions", icon: IoReceiptOutline, label: t("transactions") || "Transactions" },
    { path: "/orders", icon: IoDocumentTextOutline, label: t("orders") || "Orders" },
    { path: "/support", icon: IoChatbubblesOutline, label: t("support_nav") || "Support" },
  ];

  // Navigation items for guests (non-authenticated users)
  const guestNavItems = [
    { path: "/services", icon: IoGridOutline, label: t("services") || "Services" },
    { path: "/support", icon: IoChatbubblesOutline, label: t("support_nav") || "Support" },
  ];

  const navItems = isAuth ? authNavItems : guestNavItems;

  const isActiveRoute = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <Wrapper>
      <StyledContainer>
        <LeftSection>
          <HeaderLogoComponent />
        </LeftSection>

        {width > 768 && (
          <NavTabs>
            {navItems.map((item) => (
              <NavTab 
                key={item.path} 
                to={item.path}
                className={isActiveRoute(item.path) ? "active" : ""}
              >
                <NavIcon>
                  <item.icon />
                </NavIcon>
                <NavText>{item.label}</NavText>
                {item.path === "/support" && <SupportUnreadBadge />}
              </NavTab>
            ))}
          </NavTabs>
        )}

        <HeaderNavigationComponent />
      </StyledContainer>
    </Wrapper>
  );
};

export default HeaderComponent;
